import React from 'react'
import { Card as CardComponent } from 'theme-ui'
import { Layout, Stack, Main, Sidebar, Hero } from '@layout'
import CardList from '@components/CardList'
import Card from '@components/Card'
import Divider from '@components/Divider'
import Sticky from '@components/Sticky'
import Seo from '@widgets/Seo'
import AuthorCompact from '@widgets/AuthorCompact'
import TableOfContentsCompact from '@widgets/TableOfContentsCompact'
import NewsletterExpanded from '@widgets/NewsletterExpanded'
import {
  PostBody,
  PostComments,
  PostTagsShare,
  PostFooter,
} from '@widgets/Post'

const Post = ({
  data: { post, tagCategoryPosts, tagPosts, categoryPosts, previous, next },
  ...props
}) => {
  const relatedPosts = [
    ...(tagCategoryPosts ? tagCategoryPosts.nodes : []),
    ...(tagPosts ? tagPosts.nodes : []),
    ...(categoryPosts ? categoryPosts.nodes : []),
  ]
  const { pageContext: { services = {}, siteUrl } = {} } = props

  return (
    <Layout {...props}>
      <div id='fb-root'></div>

      <div id='fb-customer-chat' class='fb-customerchat'></div>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .post-body p:has(> img){
              margin: 2em 0;
              aspect-ratio: 2 / 1;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-wrap: wrap;
            }

            .post-body img{
              background-color: #eee;
            }

            .post-body p, .post-body ol, .post-body ul{
              padding: 0 0.8em;
            }

            html, body{
              overflow-x: hidden;
            }

            .sl-banner img{
                width: 100%;
                margin-bottom: 1em;
            }

            @media screen and (max-width: 480px) {
              .sl-banner img:last-child {
                display: none;
              }

              .sl-banner img:first-child {
                display: block;
              }
            }

            @media screen and (min-width: 480px) {

              .sl-banner img:first-child {
                display: none;
              }
              .sl-banner img:last-child {
                display: block;
              }
            }
      `,
        }}
      ></style>

      <script
        dangerouslySetInnerHTML={{
          __html: `
      var chatbox = document.getElementById('fb-customer-chat');
      chatbox.setAttribute("page_id", "100247698049365");
      chatbox.setAttribute("attribution", "biz_inbox");
    `,
        }}
      ></script>

      <script
        dangerouslySetInnerHTML={{
          __html: `
    window.fbAsyncInit = function() {
        FB.init({
          xfbml            : true,
          version          : 'v15.0'
        });
      };

      (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    `,
        }}
      ></script>

      <Seo {...post} siteUrl={siteUrl} />
      <Hero full>
        <Card {...post} variant='horizontal-cover-hero' omitExcerpt />
      </Hero>
      <Divider />
      <Stack effectProps={{ fraction: 0 }}>
        <Main>
          <CardComponent variant='paper'>
            <div className='post-body'>
              <PostBody {...post} />
            </div>

            <PostTagsShare {...post} location={props.location} />
            {services.disqus && <PostComments {...post} />}
            <PostFooter {...{ previous, next }} />
          </CardComponent>

          {services.mailchimp && (
            <>
              <Divider />
              <NewsletterExpanded simple />
            </>
          )}
        </Main>
        <Sidebar>
          <AuthorCompact author={post.author} omitTitle />
          <Divider />
          <Sticky>
            {post.tableOfContents?.items && (
              <>
                <TableOfContentsCompact {...post} />
                <Divider />
              </>
            )}
            {post.category && (
              <CardList
                title='Related Posts'
                nodes={relatedPosts}
                variant='horizontal-aside'
                limit={6}
                omitMedia
                omitCategory
                distinct
                aside
              />
            )}
          </Sticky>
        </Sidebar>
      </Stack>
    </Layout>
  )
}

export default Post
